import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-calendar-edit",
  templateUrl: "./med-icon-calendar-edit.component.html",
})
export class MedIconCalendarEditComponent extends SvgMixinComponent {}
